webpackJsonp([0],{

/***/ 125:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export VimeoVideo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return Home; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return NotFound; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return Auth; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return App; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames_bind__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_whatwg_fetch__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_visibility_sensor__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_visibility_sensor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_visibility_sensor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_styl__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__App_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__react_logo_png__ = __webpack_require__(344);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__react_logo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__react_logo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_background_jpg__ = __webpack_require__(345);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__images_background_jpg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__images_background_jpg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_share_png__ = __webpack_require__(347);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__images_share_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__images_share_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_lock_png__ = __webpack_require__(346);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__images_lock_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__images_lock_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pw__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__pw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__pw__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__videoData_json__ = __webpack_require__(206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__videoData_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__videoData_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__favicon_ico__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__favicon_ico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__favicon_ico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__utils__ = __webpack_require__(127);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








// Using CSS Modules so we assign the styles to a variable

var cx = __WEBPACK_IMPORTED_MODULE_3_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_6__App_styl___default.a);







// Favicon link is in the template, this just makes webpack package it up for us



var storage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils__["a" /* store */])();

var VimeoVideo = function (_React$Component) {
  _inherits(VimeoVideo, _React$Component);

  function VimeoVideo(props) {
    _classCallCheck(this, VimeoVideo);

    var _this = _possibleConstructorReturn(this, (VimeoVideo.__proto__ || Object.getPrototypeOf(VimeoVideo)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(VimeoVideo, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (this.props.autoplay) {
        this.play();
        this.myRef.scrollIntoView({ behavior: 'smooth', block: 'center', inline: 'center' });
      }
    }
  }, {
    key: 'load',
    value: function load() {
      var _this2 = this;

      this.thePlayer = new Vimeo.Player('vimeo-' + this.props.id, {
        width: __WEBPACK_IMPORTED_MODULE_14__utils__["b" /* isMobile */] ? 160 : 275,
        autoplay: !__WEBPACK_IMPORTED_MODULE_14__utils__["b" /* isMobile */],
        playsinline: false,
        responsive: true
      });
      this.thePlayer.ready().then(function () {
        _this2.setState({ loaded: true, loading: false });
      });
    }
  }, {
    key: 'markAsPlayed',
    value: function markAsPlayed() {
      var playedVideos = JSON.parse(storage.getItem('playedVideos') || '{}');
      playedVideos[this.props.id] = new Date().getTime();
      storage.setItem('playedVideos', JSON.stringify(playedVideos));
    }
  }, {
    key: 'play',
    value: function play() {
      var _this3 = this;

      this.load();
      this.markAsPlayed();
      this.setState({ loading: true });
      this.thePlayer.on('play', function () {
        _this3.thePlayer.requestFullscreen();
      });
      this.thePlayer.on('fullscreenchange', function (_ref) {
        var fullscreen = _ref.fullscreen;

        if (!fullscreen) _this3.thePlayer.pause();
      });
    }
  }, {
    key: 'visibilityChange',
    value: function visibilityChange(isVisible) {
      if (__WEBPACK_IMPORTED_MODULE_14__utils__["b" /* isMobile */] && isVisible && !this.thePlayer) {
        this.load();
      }
    }
  }, {
    key: 'hasPlayedVideo',
    value: function hasPlayedVideo(id, _ref2) {
      var ids = _ref2.ids;

      return ids.includes(id);
    }
  }, {
    key: 'formatPlayedDate',
    value: function formatPlayedDate(id, _ref3) {
      var timestamps = _ref3.timestamps;

      var o_date_en = new Intl.DateTimeFormat('en');
      var f_date = function f_date(m_ca, m_it) {
        return Object(_extends({}, m_ca, _defineProperty({}, m_it.type, m_it.value)));
      };

      var _o_date_en$formatToPa = o_date_en.formatToParts(timestamps[id]).reduce(f_date, {}),
          month = _o_date_en$formatToPa.month,
          day = _o_date_en$formatToPa.day,
          year = _o_date_en$formatToPa.year;

      return month + '/' + day + '/' + year;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        __WEBPACK_IMPORTED_MODULE_5_react_visibility_sensor___default.a,
        { onChange: this.visibilityChange.bind(this) },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('video', { selected: this.props.autoplay }), ref: function ref(_ref4) {
              return _this4.myRef = _ref4;
            } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: cx('video-inside') },
            !this.state.loaded && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: cx('video-thumbnail'), style: { 'backgroundImage': 'url(' + this.props.thumbnail + ')' }, onClick: this.play.bind(this) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: cx('video-play-button') },
                !this.state.loading ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'svg',
                  { viewBox: '0 0 20 20', preserveAspectRatio: 'xMidYMid', className: cx('video-play-icon') },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'title',
                    { id: 'play-icon-title' },
                    'Play'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon', { points: '1,0 20,10 1,20' })
                ) : __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'svg',
                  { viewBox: '0 0 20 20', preserveAspectRatio: 'xMidYMid', className: cx('video-play-icon') },
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                    'title',
                    { id: 'pause-icon-title' },
                    'Pause'
                  ),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { width: '6', height: '20', x: '0', y: '0' }),
                  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect', { width: '6', height: '20', x: '12', y: '0' })
                )
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: cx('video-placeholder'), 'data-vimeo-id': this.props.id, id: 'vimeo-' + this.props.id }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'a',
              { href: '/video/' + this.props.id, target: '_blank' },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img', { className: cx('share-button'), src: __WEBPACK_IMPORTED_MODULE_9__images_share_png___default.a })
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h4',
              null,
              this.props.name
            ),
            this.hasPlayedVideo(this.props.id, this.props.playedVideos) ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: cx('recently-played') },
              'Watched'
            ) : '',
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h5',
              null,
              this.props.date
            )
          )
        )
      );
    }
  }]);

  return VimeoVideo;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var sectionColors = ['#dee6e6', '#ebf0f0'];

var VideoSection = function (_React$Component2) {
  _inherits(VideoSection, _React$Component2);

  function VideoSection() {
    _classCallCheck(this, VideoSection);

    return _possibleConstructorReturn(this, (VideoSection.__proto__ || Object.getPrototypeOf(VideoSection)).apply(this, arguments));
  }

  _createClass(VideoSection, [{
    key: 'render',
    value: function render() {
      var _this6 = this;

      var videos = [].concat(_toConsumableArray(this.props.videos));
      videos.sort(function (a, b) {
        var _a$date$split = a.date.split('/'),
            _a$date$split2 = _slicedToArray(_a$date$split, 3),
            a1 = _a$date$split2[0],
            a2 = _a$date$split2[1],
            a3 = _a$date$split2[2];

        var _b$date$split = b.date.split('/'),
            _b$date$split2 = _slicedToArray(_b$date$split, 3),
            b1 = _b$date$split2[0],
            b2 = _b$date$split2[1],
            b3 = _b$date$split2[2];

        var aDate = a1 + '/' + a2 + '/' + a3;
        var bDate = b1 + '/' + b2 + '/' + b3;

        if (!a2) aDate = '12/31/' + a1;
        if (!b2) bDate = '12/31/' + b1;

        if (a2 && !a3) aDate = a1 + '/1/' + a2;
        if (b2 && !b3) bDate = b1 + '/1/' + b2;

        return new Date(aDate).getTime() - new Date(bDate).getTime();
      });

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: cx('video-section') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('video-section-year') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h3',
            null,
            this.props.year
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('videos') },
          videos.map(function (video) {
            return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VimeoVideo, _extends({}, video, {
              playedVideos: _this6.props.playedVideos,
              key: 'vid-' + video.id,
              autoplay: _this6.props.linkedVideo == video.id
            }));
          })
        )
      );
    }
  }]);

  return VideoSection;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var VideoSections = function (_React$Component3) {
  _inherits(VideoSections, _React$Component3);

  function VideoSections() {
    _classCallCheck(this, VideoSections);

    return _possibleConstructorReturn(this, (VideoSections.__proto__ || Object.getPrototypeOf(VideoSections)).apply(this, arguments));
  }

  _createClass(VideoSections, [{
    key: 'render',
    value: function render() {
      var dates = Object.keys(this.props.videos);
      var dateRange = [Math.min.apply(Math, _toConsumableArray(dates)), Math.max.apply(Math, _toConsumableArray(dates))];
      var toRender = [];
      var usedYear = 0;

      var playedVideos = JSON.parse(storage.getItem('playedVideos') || '{}');
      try {
        for (var i = dateRange[0]; i <= dateRange[1]; i++) {
          if (this.props.videos[i]) {
            usedYear++;
            toRender.push(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VideoSection, {
              year: i,
              videos: this.props.videos[i],
              key: 'section-' + i,
              bg: sectionColors[usedYear % 2],
              playedVideos: { ids: Object.keys(playedVideos), timestamps: playedVideos },
              linkedVideo: this.props.linkedVideo
            }));
          }
        }
      } catch (e) {
        console.log(e);
      }
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        null,
        toRender
      );
    }
  }]);

  return VideoSections;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Stats = function (_React$Component4) {
  _inherits(Stats, _React$Component4);

  function Stats() {
    _classCallCheck(this, Stats);

    return _possibleConstructorReturn(this, (Stats.__proto__ || Object.getPrototypeOf(Stats)).apply(this, arguments));
  }

  _createClass(Stats, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: cx('stat-box') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('stat') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: cx('stat-number') },
            this.props.videoCount
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: cx('stat-text') },
            'videos'
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('stat') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: cx('stat-number') },
            Object.keys(this.props.videos).length
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: cx('stat-text') },
            'years'
          )
        )
      );
    }
  }]);

  return Stats;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Header = function (_React$Component5) {
  _inherits(Header, _React$Component5);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, [{
    key: 'onClick',
    value: function onClick() {
      this.ref.scrollIntoView({ behavior: 'smooth' });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this10 = this;

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: cx('header-outside') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('header'), style: { background: 'url(' + __WEBPACK_IMPORTED_MODULE_8__images_background_jpg___default.a + ') no-repeat center 70%' } },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: cx('header-border') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: cx('header-text') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'h1',
                null,
                'Stein Family'
              ),
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: cx('h2-background') },
                __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                  'h2',
                  null,
                  'Home Videos'
                )
              )
            ),
            this.props.noButton !== true && __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: cx('header-below'), onClick: this.onClick.bind(this) },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: cx('header-arrow') })
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { ref: function ref(_ref5) {
            return _this10.ref = _ref5;
          } })
      );
    }
  }]);

  return Header;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Home = function (_React$Component6) {
  _inherits(Home, _React$Component6);

  function Home(props) {
    _classCallCheck(this, Home);

    var _this11 = _possibleConstructorReturn(this, (Home.__proto__ || Object.getPrototypeOf(Home)).call(this, props));

    _this11.state = {};
    return _this11;
  }

  _createClass(Home, [{
    key: 'onChange',
    value: function onChange() {
      this.setState({
        thing: Math.random()
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var userPass = storage.getItem('password');

      // FOR BUiLD
      if (userPass == '__IS_BUILD__') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('page') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Header, null)
        );
      }

      if (!userPass || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils__["c" /* hashPass */])(userPass) !== +__WEBPACK_IMPORTED_MODULE_11__pw___default.a) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('page') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Auth, { onChange: this.onChange.bind(this) })
        );
      }

      if (!this.props.videoCount) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('page') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Header, null),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: cx('loading') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', { className: cx('loader') }),
            'Loading videos'
          )
        );
      }

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: cx('page') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Header, null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Stats, this.props),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(VideoSections, { videos: this.props.videos, linkedVideo: this.props.linkedVideo }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Footer, null)
      );
    }
  }]);

  return Home;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Footer = function (_React$Component7) {
  _inherits(Footer, _React$Component7);

  function Footer() {
    _classCallCheck(this, Footer);

    return _possibleConstructorReturn(this, (Footer.__proto__ || Object.getPrototypeOf(Footer)).apply(this, arguments));
  }

  _createClass(Footer, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: cx('footer') },
        'Made with ',
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'span',
          null,
          '\u2665'
        ),
        ' by Tyke'
      );
    }
  }]);

  return Footer;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var NotFound = function (_React$Component8) {
  _inherits(NotFound, _React$Component8);

  function NotFound() {
    _classCallCheck(this, NotFound);

    return _possibleConstructorReturn(this, (NotFound.__proto__ || Object.getPrototypeOf(NotFound)).apply(this, arguments));
  }

  _createClass(NotFound, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: cx('page') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'h4',
          null,
          'Not found'
        )
      );
    }
  }]);

  return NotFound;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Auth = function (_React$Component9) {
  _inherits(Auth, _React$Component9);

  function Auth(props) {
    _classCallCheck(this, Auth);

    var _this14 = _possibleConstructorReturn(this, (Auth.__proto__ || Object.getPrototypeOf(Auth)).call(this, props));

    _this14.state = {};
    return _this14;
  }

  _createClass(Auth, [{
    key: 'onChange',
    value: function onChange(e) {
      this.setState({
        password: e.target.value
      });
    }
  }, {
    key: 'handleKeyPress',
    value: function handleKeyPress(evt) {
      if (evt.key == 'Enter') {
        this.attemptPassword();
      }
    }
  }, {
    key: 'attemptPassword',
    value: function attemptPassword() {
      var hashedPass = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_14__utils__["c" /* hashPass */])(this.state.password);

      if (hashedPass === +__WEBPACK_IMPORTED_MODULE_11__pw___default.a) {
        storage.setItem('password', this.state.password);
        this.props.onChange();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: cx('auth'), style: { background: 'url(' + __WEBPACK_IMPORTED_MODULE_8__images_background_jpg___default.a + ') no-repeat center 70%' } },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('auth-outside') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: cx('auth-inside') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: cx('auth-header') },
              __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
                'div',
                { className: cx('auth-text') },
                'Please enter password to continue.'
              )
            ),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input', { className: cx('auth-input'), onChange: this.onChange.bind(this), type: 'password', onKeyPress: this.handleKeyPress.bind(this) }),
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'div',
              { className: cx('button'), onClick: this.attemptPassword.bind(this) },
              'Continue'
            )
          )
        ),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Header, { noButton: true })
      );
    }
  }]);

  return Auth;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var App = function (_React$Component10) {
  _inherits(App, _React$Component10);

  function App(props) {
    _classCallCheck(this, App);

    var _this15 = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));

    _this15.state = {
      videos: [],
      videoCount: 0,
      linkedVideo: props.params ? props.params.videoId : 0
    };
    return _this15;
  }

  _createClass(App, [{
    key: 'getThumbnail',
    value: function getThumbnail(_ref6) {
      var pictures = _ref6.pictures;
      var sizes = pictures.sizes;

      var res = void 0;
      for (var i = 0; i < sizes.length; i++) {
        if (sizes[i].width > 350) {
          res = sizes[i].link;
          break;
        }
      }
      return res;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      setTimeout(function () {
        var vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', vh + 'px');
      }, 500);
    }
  }, {
    key: 'fetchVideoData',
    value: function fetchVideoData() {
      var _this16 = this;

      window.fetch('https://api.vimeo.com/users/53248139/projects/3061216/videos?per_page=100', {
        method: 'GET',
        headers: {
          'Authorization': 'bearer e33da6729f9b3e2342a474ede5a4afc1'
        }
      }).then(function (response) {
        return response.json();
      }).then(function (responseData) {
        console.log(responseData);
        try {
          var videosByDate = {};
          var videoCount = responseData.data.length;
          responseData.data.map(function (vid) {
            var _vid$name$split = vid.name.split(' | '),
                _vid$name$split2 = _slicedToArray(_vid$name$split, 2),
                videoDate = _vid$name$split2[0],
                videoName = _vid$name$split2[1];

            var _vid$uri$split = vid.uri.split('/'),
                _vid$uri$split2 = _slicedToArray(_vid$uri$split, 3),
                id = _vid$uri$split2[2];

            var thumbnail = _this16.getThumbnail(vid);

            var year = function (date) {
              if (date.indexOf('/') > -1) {
                var _date$split = date.split('/'),
                    _date$split2 = _slicedToArray(_date$split, 3),
                    yrr = _date$split2[1],
                    yr = _date$split2[2];

                if (yr) return yr;
                return yrr;
              } else {
                return date;
              }
            }(videoDate);

            videosByDate[year] = videosByDate[year] || [];
            videosByDate[year].push({
              date: videoDate,
              name: videoName,
              id: id,
              thumbnail: thumbnail
            });
          });

          _this16.setState({
            videos: videosByDate,
            videoCount: videoCount
          });
        } catch (e) {
          console.log(e);
        }
      }).catch(function (e) {
        console.log(e);
      });
    }
  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      if (__WEBPACK_IMPORTED_MODULE_12__videoData_json___default.a) {
        this.setState({
          videos: __WEBPACK_IMPORTED_MODULE_12__videoData_json___default.a.videos,
          videoCount: __WEBPACK_IMPORTED_MODULE_12__videoData_json___default.a.count
        });
      } else {
        this.fetchVideoData();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: cx('App') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(this.props.children, _extends({}, this.state))
      );
    }
  }]);

  return App;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
App.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

/***/ }),

/***/ 126:
/***/ (function(module, exports) {

module.exports = '108101';

/***/ }),

/***/ 127:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isMobile; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hashPass; });
// This is a polyfill for the compiler. It is dumb
var store = function store() {
  var _storage = {
    _data: {},
    setItem: function setItem(id, val) {
      return this._data[id] = val;
    },
    getItem: function getItem(id) {
      return '__IS_BUILD__';
    }
  };
  if (typeof localStorage !== 'undefined') _storage = localStorage;
  return _storage;
};

var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

var hashPass = function hashPass(x) {
  if (!x) return 0;
  var hash = 0;
  if (x.length == 0) {
    return hash;
  }
  for (var i = 0; i < x.length; i++) {
    var char = x.charCodeAt(i);
    hash = (hash << 5) - hash + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return hash;
};

/***/ }),

/***/ 128:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(this && this[arg] || arg);
			} else if (Array.isArray(arg)) {
				classes.push(classNames.apply(this, arg));
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(this && this[key] || key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),

/***/ 154:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"auth":"_2TnOWG67","auth-outside":"_2GtLxBlP","auth-inside":"_2VAYoztq","auth-lock":"_25c5rK-X","auth-text":"_3Aljh5jd","auth-subtext":"fjLKjeNg","auth-input":"_28A0IrDE","button":"_2uSFw3jY","header-outside":"_1n0SSR5W","header":"Pgx3t7H9","header-text":"jF1l4_AY","header-border":"_2wGdNIVl","h2-background":"_3YmIuj0a","header-below":"_3INMMSV4","header-arrow":"_3464meTT","bounce":"_3oLfoMYu","loading":"_1Aya0bOW","loader":"Jgyhau4Q","load8":"XlbaApbT","stat-box":"_23Db74Dx","stat":"_1WcIl9Fk","stat-number":"_2dE9GOpO","stat-text":"yvUP8cqK","video-section":"_37A3KuR3","video-section-year":"_1YT-Bj8f","videos":"_1gfI3ni4","video":"L-USYQYf","share-button":"_1F7SvpH6","selected":"ROvQkTZM","video-inside":"_1UDN0bW0","video-play-button":"_3lLUGfT9","video-placeholder":"_3kgdX5de","video-thumbnail":"_1gnwLukC","video-play-icon":"xH3Mbpmb","recently-played":"_35CfMKHJ","footer":"_2m1efwi9","single-video":"_2_WRsath","main-video":"_2Bukhal9","video-player":"_3y-jN1Q1","single-header":"_2s3BGh9G","back-home":"iGPqkWTg","back-home-btn":"ieUHlZAa"};

/***/ }),

/***/ 158:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "favicon.fd73a6eb.ico";

/***/ }),

/***/ 194:
/***/ (function(module, exports, __webpack_require__) {

(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory(__webpack_require__(11), __webpack_require__(81));
	else if(typeof define === 'function' && define.amd)
		define(["React", "ReactDOM"], factory);
	else if(typeof exports === 'object')
		exports["react-visibility-sensor"] = factory(require("react"), require("react-dom"));
	else
		root["react-visibility-sensor"] = factory(root["React"], root["ReactDOM"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE__1__, __WEBPACK_EXTERNAL_MODULE__2__) {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
/******/ 		}
/******/ 	};
/******/
/******/ 	// define __esModule on exports
/******/ 	__webpack_require__.r = function(exports) {
/******/ 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 		}
/******/ 		Object.defineProperty(exports, '__esModule', { value: true });
/******/ 	};
/******/
/******/ 	// create a fake namespace object
/******/ 	// mode & 1: value is a module id, require it
/******/ 	// mode & 2: merge all properties of value into the ns
/******/ 	// mode & 4: return value when already ns object
/******/ 	// mode & 8|1: behave like require
/******/ 	__webpack_require__.t = function(value, mode) {
/******/ 		if(mode & 1) value = __webpack_require__(value);
/******/ 		if(mode & 8) return value;
/******/ 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
/******/ 		var ns = Object.create(null);
/******/ 		__webpack_require__.r(ns);
/******/ 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
/******/ 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
/******/ 		return ns;
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 4);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) { var throwOnDirectAccess, ReactIs; } else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(5)();
}


/***/ }),
/* 1 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__1__;

/***/ }),
/* 2 */
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__2__;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// Tell whether the rect is visible, given an offset
//
// return: boolean
module.exports = function (offset, rect, containmentRect) {
  var offsetDir = offset.direction;
  var offsetVal = offset.value; // Rules for checking different kind of offsets. In example if the element is
  // 90px below viewport and offsetTop is 100, it is considered visible.

  switch (offsetDir) {
    case 'top':
      return containmentRect.top + offsetVal < rect.top && containmentRect.bottom > rect.bottom && containmentRect.left < rect.left && containmentRect.right > rect.right;

    case 'left':
      return containmentRect.left + offsetVal < rect.left && containmentRect.bottom > rect.bottom && containmentRect.top < rect.top && containmentRect.right > rect.right;

    case 'bottom':
      return containmentRect.bottom - offsetVal > rect.bottom && containmentRect.left < rect.left && containmentRect.right > rect.right && containmentRect.top < rect.top;

    case 'right':
      return containmentRect.right - offsetVal > rect.right && containmentRect.left < rect.left && containmentRect.top < rect.top && containmentRect.bottom > rect.bottom;
  }
};

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return VisibilitySensor; });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(1);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react_dom__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(0);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _lib_is_visible_with_offset__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3);
/* harmony import */ var _lib_is_visible_with_offset__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_lib_is_visible_with_offset__WEBPACK_IMPORTED_MODULE_3__);


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }






function normalizeRect(rect) {
  if (rect.width === undefined) {
    rect.width = rect.right - rect.left;
  }

  if (rect.height === undefined) {
    rect.height = rect.bottom - rect.top;
  }

  return rect;
}

var VisibilitySensor =
/*#__PURE__*/
function (_React$Component) {
  _inherits(VisibilitySensor, _React$Component);

  function VisibilitySensor(props) {
    var _this;

    _classCallCheck(this, VisibilitySensor);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(VisibilitySensor).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "getContainer", function () {
      return _this.props.containment || window;
    });

    _defineProperty(_assertThisInitialized(_this), "addEventListener", function (target, event, delay, throttle) {
      if (!_this.debounceCheck) {
        _this.debounceCheck = {};
      }

      var timeout;
      var func;

      var later = function later() {
        timeout = null;

        _this.check();
      };

      if (throttle > -1) {
        func = function func() {
          if (!timeout) {
            timeout = setTimeout(later, throttle || 0);
          }
        };
      } else {
        func = function func() {
          clearTimeout(timeout);
          timeout = setTimeout(later, delay || 0);
        };
      }

      var info = {
        target: target,
        fn: func,
        getLastTimeout: function getLastTimeout() {
          return timeout;
        }
      };
      target.addEventListener(event, info.fn);
      _this.debounceCheck[event] = info;
    });

    _defineProperty(_assertThisInitialized(_this), "startWatching", function () {
      if (_this.debounceCheck || _this.interval) {
        return;
      }

      if (_this.props.intervalCheck) {
        _this.interval = setInterval(_this.check, _this.props.intervalDelay);
      }

      if (_this.props.scrollCheck) {
        _this.addEventListener(_this.getContainer(), "scroll", _this.props.scrollDelay, _this.props.scrollThrottle);
      }

      if (_this.props.resizeCheck) {
        _this.addEventListener(window, "resize", _this.props.resizeDelay, _this.props.resizeThrottle);
      } // if dont need delayed call, check on load ( before the first interval fires )


      !_this.props.delayedCall && _this.check();
    });

    _defineProperty(_assertThisInitialized(_this), "stopWatching", function () {
      if (_this.debounceCheck) {
        // clean up event listeners and their debounce callers
        for (var debounceEvent in _this.debounceCheck) {
          if (_this.debounceCheck.hasOwnProperty(debounceEvent)) {
            var debounceInfo = _this.debounceCheck[debounceEvent];
            clearTimeout(debounceInfo.getLastTimeout());
            debounceInfo.target.removeEventListener(debounceEvent, debounceInfo.fn);
            _this.debounceCheck[debounceEvent] = null;
          }
        }
      }

      _this.debounceCheck = null;

      if (_this.interval) {
        _this.interval = clearInterval(_this.interval);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "check", function () {
      var el = _this.node;
      var rect;
      var containmentRect; // if the component has rendered to null, dont update visibility

      if (!el) {
        return _this.state;
      }

      rect = normalizeRect(_this.roundRectDown(el.getBoundingClientRect()));

      if (_this.props.containment) {
        var containmentDOMRect = _this.props.containment.getBoundingClientRect();

        containmentRect = {
          top: containmentDOMRect.top,
          left: containmentDOMRect.left,
          bottom: containmentDOMRect.bottom,
          right: containmentDOMRect.right
        };
      } else {
        containmentRect = {
          top: 0,
          left: 0,
          bottom: window.innerHeight || document.documentElement.clientHeight,
          right: window.innerWidth || document.documentElement.clientWidth
        };
      } // Check if visibility is wanted via offset?


      var offset = _this.props.offset || {};
      var hasValidOffset = _typeof(offset) === "object";

      if (hasValidOffset) {
        containmentRect.top += offset.top || 0;
        containmentRect.left += offset.left || 0;
        containmentRect.bottom -= offset.bottom || 0;
        containmentRect.right -= offset.right || 0;
      }

      var visibilityRect = {
        top: rect.top >= containmentRect.top,
        left: rect.left >= containmentRect.left,
        bottom: rect.bottom <= containmentRect.bottom,
        right: rect.right <= containmentRect.right
      }; // https://github.com/joshwnj/react-visibility-sensor/pull/114

      var hasSize = rect.height > 0 && rect.width > 0;
      var isVisible = hasSize && visibilityRect.top && visibilityRect.left && visibilityRect.bottom && visibilityRect.right; // check for partial visibility

      if (hasSize && _this.props.partialVisibility) {
        var partialVisible = rect.top <= containmentRect.bottom && rect.bottom >= containmentRect.top && rect.left <= containmentRect.right && rect.right >= containmentRect.left; // account for partial visibility on a single edge

        if (typeof _this.props.partialVisibility === "string") {
          partialVisible = visibilityRect[_this.props.partialVisibility];
        } // if we have minimum top visibility set by props, lets check, if it meets the passed value
        // so if for instance element is at least 200px in viewport, then show it.


        isVisible = _this.props.minTopValue ? partialVisible && rect.top <= containmentRect.bottom - _this.props.minTopValue : partialVisible;
      } // Deprecated options for calculating offset.


      if (typeof offset.direction === "string" && typeof offset.value === "number") {
        console.warn("[notice] offset.direction and offset.value have been deprecated. They still work for now, but will be removed in next major version. Please upgrade to the new syntax: { %s: %d }", offset.direction, offset.value);
        isVisible = _lib_is_visible_with_offset__WEBPACK_IMPORTED_MODULE_3___default()(offset, rect, containmentRect);
      }

      var state = _this.state; // notify the parent when the value changes

      if (_this.state.isVisible !== isVisible) {
        state = {
          isVisible: isVisible,
          visibilityRect: visibilityRect
        };

        _this.setState(state);

        if (_this.props.onChange) _this.props.onChange(isVisible);
      }

      return state;
    });

    _this.state = {
      isVisible: null,
      visibilityRect: {}
    };
    return _this;
  }

  _createClass(VisibilitySensor, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.node = react_dom__WEBPACK_IMPORTED_MODULE_1___default.a.findDOMNode(this);

      if (this.props.active) {
        this.startWatching();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.stopWatching();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // re-register node in componentDidUpdate if children diffs [#103]
      this.node = react_dom__WEBPACK_IMPORTED_MODULE_1___default.a.findDOMNode(this);

      if (this.props.active && !prevProps.active) {
        this.setState({
          isVisible: null,
          visibilityRect: {}
        });
        this.startWatching();
      } else if (!this.props.active) {
        this.stopWatching();
      }
    }
  }, {
    key: "roundRectDown",
    value: function roundRectDown(rect) {
      return {
        top: Math.floor(rect.top),
        left: Math.floor(rect.left),
        bottom: Math.floor(rect.bottom),
        right: Math.floor(rect.right)
      };
    }
    /**
     * Check if the element is within the visible viewport
     */

  }, {
    key: "render",
    value: function render() {
      if (this.props.children instanceof Function) {
        return this.props.children({
          isVisible: this.state.isVisible,
          visibilityRect: this.state.visibilityRect
        });
      }

      return react__WEBPACK_IMPORTED_MODULE_0___default.a.Children.only(this.props.children);
    }
  }]);

  return VisibilitySensor;
}(react__WEBPACK_IMPORTED_MODULE_0___default.a.Component);

_defineProperty(VisibilitySensor, "defaultProps", {
  active: true,
  partialVisibility: false,
  minTopValue: 0,
  scrollCheck: false,
  scrollDelay: 250,
  scrollThrottle: -1,
  resizeCheck: false,
  resizeDelay: 250,
  resizeThrottle: -1,
  intervalCheck: true,
  intervalDelay: 100,
  delayedCall: false,
  offset: {},
  containment: null,
  children: react__WEBPACK_IMPORTED_MODULE_0___default.a.createElement("span", null)
});

_defineProperty(VisibilitySensor, "propTypes", {
  onChange: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func,
  active: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  partialVisibility: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool, prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOf(["top", "right", "bottom", "left"])]),
  delayedCall: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  offset: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.shape({
    top: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
    left: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
    bottom: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
    right: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number
  }), // deprecated offset property
  prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.shape({
    direction: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOf(["top", "right", "bottom", "left"]),
    value: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number
  })]),
  scrollCheck: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  scrollDelay: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
  scrollThrottle: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
  resizeCheck: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  resizeDelay: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
  resizeThrottle: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
  intervalCheck: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.bool,
  intervalDelay: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number,
  containment: typeof window !== "undefined" ? prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.instanceOf(window.Element) : prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.any,
  children: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.oneOfType([prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.element, prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.func]),
  minTopValue: prop_types__WEBPACK_IMPORTED_MODULE_2___default.a.number
});



/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(6);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ })
/******/ ]);
});

/***/ }),

/***/ 200:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export Headers */
/* unused harmony export Request */
/* unused harmony export Response */
/* unused harmony export DOMException */
/* unused harmony export fetch */
var global =
  (typeof globalThis !== 'undefined' && globalThis) ||
  (typeof self !== 'undefined' && self) ||
  (typeof global !== 'undefined' && global)

var support = {
  searchParams: 'URLSearchParams' in global,
  iterable: 'Symbol' in global && 'iterator' in Symbol,
  blob:
    'FileReader' in global &&
    'Blob' in global &&
    (function() {
      try {
        new Blob()
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in global,
  arrayBuffer: 'ArrayBuffer' in global
}

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj)
}

if (support.arrayBuffer) {
  var viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'
  ]

  var isArrayBufferView =
    ArrayBuffer.isView ||
    function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name)
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
    throw new TypeError('Invalid character in header field name')
  }
  return name.toLowerCase()
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value)
  }
  return value
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift()
      return {done: value === undefined, value: value}
    }
  }

  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator
    }
  }

  return iterator
}

function Headers(headers) {
  this.map = {}

  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value)
    }, this)
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      this.append(header[0], header[1])
    }, this)
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name])
    }, this)
  }
}

Headers.prototype.append = function(name, value) {
  name = normalizeName(name)
  value = normalizeValue(value)
  var oldValue = this.map[name]
  this.map[name] = oldValue ? oldValue + ', ' + value : value
}

Headers.prototype['delete'] = function(name) {
  delete this.map[normalizeName(name)]
}

Headers.prototype.get = function(name) {
  name = normalizeName(name)
  return this.has(name) ? this.map[name] : null
}

Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(normalizeName(name))
}

Headers.prototype.set = function(name, value) {
  this.map[normalizeName(name)] = normalizeValue(value)
}

Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this)
    }
  }
}

Headers.prototype.keys = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push(name)
  })
  return iteratorFor(items)
}

Headers.prototype.values = function() {
  var items = []
  this.forEach(function(value) {
    items.push(value)
  })
  return iteratorFor(items)
}

Headers.prototype.entries = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push([name, value])
  })
  return iteratorFor(items)
}

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries
}

function consumed(body) {
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true
}

function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result)
    }
    reader.onerror = function() {
      reject(reader.error)
    }
  })
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsArrayBuffer(blob)
  return promise
}

function readBlobAsText(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsText(blob)
  return promise
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf)
  var chars = new Array(view.length)

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i])
  }
  return chars.join('')
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0)
  } else {
    var view = new Uint8Array(buf.byteLength)
    view.set(new Uint8Array(buf))
    return view.buffer
  }
}

function Body() {
  this.bodyUsed = false

  this._initBody = function(body) {
    /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */
    this.bodyUsed = this.bodyUsed
    this._bodyInit = body
    if (!body) {
      this._bodyText = ''
    } else if (typeof body === 'string') {
      this._bodyText = body
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString()
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer)
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer])
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body)
    } else {
      this._bodyText = body = Object.prototype.toString.call(body)
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8')
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type)
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
      }
    }
  }

  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob')
      } else {
        return Promise.resolve(new Blob([this._bodyText]))
      }
    }

    this.arrayBuffer = function() {
      if (this._bodyArrayBuffer) {
        var isConsumed = consumed(this)
        if (isConsumed) {
          return isConsumed
        }
        if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
          return Promise.resolve(
            this._bodyArrayBuffer.buffer.slice(
              this._bodyArrayBuffer.byteOffset,
              this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
            )
          )
        } else {
          return Promise.resolve(this._bodyArrayBuffer)
        }
      } else {
        return this.blob().then(readBlobAsArrayBuffer)
      }
    }
  }

  this.text = function() {
    var rejected = consumed(this)
    if (rejected) {
      return rejected
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob)
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text')
    } else {
      return Promise.resolve(this._bodyText)
    }
  }

  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode)
    }
  }

  this.json = function() {
    return this.text().then(JSON.parse)
  }

  return this
}

// HTTP methods whose capitalization should be normalized
var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

function normalizeMethod(method) {
  var upcased = method.toUpperCase()
  return methods.indexOf(upcased) > -1 ? upcased : method
}

function Request(input, options) {
  if (!(this instanceof Request)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
  }

  options = options || {}
  var body = options.body

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read')
    }
    this.url = input.url
    this.credentials = input.credentials
    if (!options.headers) {
      this.headers = new Headers(input.headers)
    }
    this.method = input.method
    this.mode = input.mode
    this.signal = input.signal
    if (!body && input._bodyInit != null) {
      body = input._bodyInit
      input.bodyUsed = true
    }
  } else {
    this.url = String(input)
  }

  this.credentials = options.credentials || this.credentials || 'same-origin'
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers)
  }
  this.method = normalizeMethod(options.method || this.method || 'GET')
  this.mode = options.mode || this.mode || null
  this.signal = options.signal || this.signal
  this.referrer = null

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests')
  }
  this._initBody(body)

  if (this.method === 'GET' || this.method === 'HEAD') {
    if (options.cache === 'no-store' || options.cache === 'no-cache') {
      // Search for a '_' parameter in the query string
      var reParamSearch = /([?&])_=[^&]*/
      if (reParamSearch.test(this.url)) {
        // If it already exists then set the value with the current time
        this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime())
      } else {
        // Otherwise add a new '_' parameter to the end with the current time
        var reQueryString = /\?/
        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime()
      }
    }
  }
}

Request.prototype.clone = function() {
  return new Request(this, {body: this._bodyInit})
}

function decode(body) {
  var form = new FormData()
  body
    .trim()
    .split('&')
    .forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
  return form
}

function parseHeaders(rawHeaders) {
  var headers = new Headers()
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
  // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
  // https://github.com/github/fetch/issues/748
  // https://github.com/zloirock/core-js/issues/751
  preProcessedHeaders
    .split('\r')
    .map(function(header) {
      return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
    })
    .forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
  return headers
}

Body.call(Request.prototype)

function Response(bodyInit, options) {
  if (!(this instanceof Response)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
  }
  if (!options) {
    options = {}
  }

  this.type = 'default'
  this.status = options.status === undefined ? 200 : options.status
  this.ok = this.status >= 200 && this.status < 300
  this.statusText = 'statusText' in options ? options.statusText : ''
  this.headers = new Headers(options.headers)
  this.url = options.url || ''
  this._initBody(bodyInit)
}

Body.call(Response.prototype)

Response.prototype.clone = function() {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  })
}

Response.error = function() {
  var response = new Response(null, {status: 0, statusText: ''})
  response.type = 'error'
  return response
}

var redirectStatuses = [301, 302, 303, 307, 308]

Response.redirect = function(url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code')
  }

  return new Response(null, {status: status, headers: {location: url}})
}

var DOMException = global.DOMException
try {
  new DOMException()
} catch (err) {
  DOMException = function(message, name) {
    this.message = message
    this.name = name
    var error = Error(message)
    this.stack = error.stack
  }
  DOMException.prototype = Object.create(Error.prototype)
  DOMException.prototype.constructor = DOMException
}

function fetch(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new Request(input, init)

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException('Aborted', 'AbortError'))
    }

    var xhr = new XMLHttpRequest()

    function abortXhr() {
      xhr.abort()
    }

    xhr.onload = function() {
      var options = {
        status: xhr.status,
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      }
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
      var body = 'response' in xhr ? xhr.response : xhr.responseText
      setTimeout(function() {
        resolve(new Response(body, options))
      }, 0)
    }

    xhr.onerror = function() {
      setTimeout(function() {
        reject(new TypeError('Network request failed'))
      }, 0)
    }

    xhr.ontimeout = function() {
      setTimeout(function() {
        reject(new TypeError('Network request failed'))
      }, 0)
    }

    xhr.onabort = function() {
      setTimeout(function() {
        reject(new DOMException('Aborted', 'AbortError'))
      }, 0)
    }

    function fixUrl(url) {
      try {
        return url === '' && global.location.href ? global.location.href : url
      } catch (e) {
        return url
      }
    }

    xhr.open(request.method, fixUrl(request.url), true)

    if (request.credentials === 'include') {
      xhr.withCredentials = true
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false
    }

    if ('responseType' in xhr) {
      if (support.blob) {
        xhr.responseType = 'blob'
      } else if (
        support.arrayBuffer &&
        request.headers.get('Content-Type') &&
        request.headers.get('Content-Type').indexOf('application/octet-stream') !== -1
      ) {
        xhr.responseType = 'arraybuffer'
      }
    }

    if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers)) {
      Object.getOwnPropertyNames(init.headers).forEach(function(name) {
        xhr.setRequestHeader(name, normalizeValue(init.headers[name]))
      })
    } else {
      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })
    }

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr)

      xhr.onreadystatechange = function() {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr)
        }
      }
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
  })
}

fetch.polyfill = true

if (!global.fetch) {
  global.fetch = fetch
  global.Headers = Headers
  global.Request = Request
  global.Response = Response
}


/***/ }),

/***/ 201:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__routes_js__ = __webpack_require__(209);




// Import your routes so that you can pass them to the <Router /> component


var setVh = function setVh() {
  var vh = window.innerHeight * 0.01;
  document.documentElement.style.setProperty('--vh', vh + 'px');
};

setVh();

if (window.location.pathname.indexOf('/video') == 0) {
  window.addEventListener('resize', setVh);
  window.addEventListener('DOMContentLoaded', setVh);
}

window.dataLayer = window.dataLayer || [];
function gtag() {
  dataLayer.push(arguments);
}
gtag('js', new Date());

gtag('config', 'G-MZZYTL11ET');

__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_react_dom__["render"])(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router__["Router"], { routes: __WEBPACK_IMPORTED_MODULE_3__routes_js__["a" /* default */], history: __WEBPACK_IMPORTED_MODULE_2_react_router__["browserHistory"] }), document.getElementById('root'));

/***/ }),

/***/ 203:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 204:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 206:
/***/ (function(module, exports) {

module.exports = {"count":75,"videos":{"1987":[{"date":"12/25/1987","name":"Rachel's first christmas pt 2","id":"493069196","thumbnail":"https://i.vimeocdn.com/video/1019635544-79f2357c74a69bf2ce6bd555249ef6fe3cf429c5ba7a3d642af6082e4008000d-d_640x360?r=pad"},{"date":"12/24/1987","name":"Rachel reading book","id":"484492861","thumbnail":"https://i.vimeocdn.com/video/1003620254-0b4b95bf24be3cd7c8e6b940f61837c27240ad39f13414dc4b6efd7b379ee94d-d_640x360?r=pad"},{"date":"12/24/1987","name":"Rachel dances to music","id":"484490750","thumbnail":"https://i.vimeocdn.com/video/1003933006-18415fbcf321dd45342db34073b1e2f24d292d135a6b8b74cdc65176b74336e3-d_640x360?r=pad"},{"date":"12/24/1987","name":"Rachel trying to walk","id":"484490575","thumbnail":"https://i.vimeocdn.com/video/1003929863-0a93f28293e4eca630de84b8d8b4a7882f0889b38ddbf0d476ed6178b0a0cf0e-d_640x360?r=pad"},{"date":"12/24/1987","name":"Rachel first steps","id":"484489504","thumbnail":"https://i.vimeocdn.com/video/1003926868-4111a2e27785b71d66fedb2cfc2d2d61d1602817697edade6ba7332a16c120f7-d_640x360?r=pad"}],"1988":[{"date":"2/13/1988","name":"Rachel and Uncle Steve","id":"493068851","thumbnail":"https://i.vimeocdn.com/video/1019635053-caa42a3064cbd0590b1f98e6de275df7e6dc33be39abd72f929752973844333e-d_640x360?r=pad"},{"date":"12/25/1988","name":"Christmas","id":"490441150","thumbnail":"https://i.vimeocdn.com/video/1014517464-18ddb0d0aab82cc2f86623834c6f9146aef6c0c546de5e98eb638881dabc8831-d_640x360?r=pad"},{"date":"1/3/1988","name":"Rachel's first birthday","id":"490440461","thumbnail":"https://i.vimeocdn.com/video/1014515993-b463d22b3dc5e8eda74fcd0bd68424d950de8e7e3464523ce23dedd10f81cc68-d_640x360?r=pad"},{"date":"1/3/1988","name":"Rachel's first birthday","id":"485308718","thumbnail":"https://i.vimeocdn.com/video/1005013093-cc1f11edc966d950c8879d370322a2de4ff8afdffd03896ee79a1d9cc07dd30e-d_640x360?r=pad"},{"date":"2/15/1988","name":"Rachel pushing walker","id":"485308440","thumbnail":"https://i.vimeocdn.com/video/1005012107-04cbb31979e52a7c885a497d51472a8cc1e0aacfe4797000870a3a11824e8b93-d_640x360?r=pad"},{"date":"2/21/1988","name":"Lenny's new tights","id":"485308394","thumbnail":"https://i.vimeocdn.com/video/1005011998-d94fd09010ddc63c23153673370ff69cbdf9c451f810f815a30482e4ec74a6da-d_640x360?r=pad"},{"date":"2/21/1988","name":"Rachel at playground","id":"485308272","thumbnail":"https://i.vimeocdn.com/video/1005011952-57dbe2aa1ce20b343f6f97b5da3ea216304144b7004c8a06dcb94dc9a6b377bd-d_640x360?r=pad"}],"1989":[{"date":"6/1989","name":"Rachel's new dress pt 2","id":"493070025","thumbnail":"https://i.vimeocdn.com/video/1019637249-241b2e5394474ed9647575bc0cb71c57d13123d1523e4a84b85cd579f1cd44cd-d_640x360?r=pad"},{"date":"6/1/1989","name":"Rachel at Baker beach : Fairfax","id":"493069517","thumbnail":"https://i.vimeocdn.com/video/1019636154-3c4b96c6b652d52cd8c27ba4ac33043e7c59191dc185cba819248706761c7299-d_640x360?r=pad"},{"date":"5/14/1989","name":"Mother's Day","id":"493068107","thumbnail":"https://i.vimeocdn.com/video/1019633503-031479241fc877b578d5b4327a986a6f089828b45789f082a42a5191031d025b-d_640x360?r=pad"},{"date":"5/28/1989","name":"Memorial Day in Mill Valley","id":"493067596","thumbnail":"https://i.vimeocdn.com/video/1019632576-549aa93634fdc7154009e73e74253abd825b48047aaa3445824aa9b6c5588824-d_640x360?r=pad"},{"date":"6/1989","name":"Rachel sings ABCs","id":"490443019","thumbnail":"https://i.vimeocdn.com/video/1014520806-280126267ed1ab52663df10c1cc6e1e222693ed75c57751871c076a20eddfe10-d_640x360?r=pad"},{"date":"6/1989","name":"Rachel's new dress","id":"490442340","thumbnail":"https://i.vimeocdn.com/video/1014519383-ede14aafc2bb43fce7698df192cff6a202f04ab66c81f17b3325f3997cbe443e-d_640x360?r=pad"},{"date":"12/1989","name":"Christmas & JoAnn's ring","id":"490440093","thumbnail":"https://i.vimeocdn.com/video/1014515204-6a9ef2fec69345d5dfa1e954cc03c64a1b1d5116800f7c4acdad146f1da5690b-d_640x360?r=pad"},{"date":"1/15/1989","name":"Rachel dance to Linda's tape","id":"487952169","thumbnail":"https://i.vimeocdn.com/video/1009851809-730737f29463e426943c25f0a6e04def947de1a89869325b4f6d20e1dcbb2d7b-d_640x360?r=pad"},{"date":"1/1989","name":"Rachel at Fairfax house","id":"487952046","thumbnail":"https://i.vimeocdn.com/video/1009851520-6d0fa5f0aef65e8dafdd1c0e1eeff8682c9893140f36613292d1b3e03ee30f5d-d_640x360?r=pad"},{"date":"1/1989","name":"Rachel doing chiropractic adjustments","id":"487951791","thumbnail":"https://i.vimeocdn.com/video/1009850912-59e769c47f5d7f1c47cdbef834b89fd586b36bc52a6ef8a0dea8b89e410ee671-d_640x360?r=pad"},{"date":"1/7/1989","name":"Rachel's second birthday","id":"485309146","thumbnail":"https://i.vimeocdn.com/video/1005013438-1ad4bdba50b7eee1df9ceb5efd58a08a71eee56641aefcf317cd77d82d6d7f07-d_640x360?r=pad"},{"date":"5/24/1989","name":"Rachel in the park","id":"484493129","thumbnail":"https://i.vimeocdn.com/video/1003930802-537d48cd8a56575a840c813a10c6230df619011b9be5f1bb4ef217bf72cec789-d_640x360?r=pad"},{"date":"5/24/1989","name":"Rachel in Fire Station","id":"484493046","thumbnail":"https://i.vimeocdn.com/video/1003620322-33099d6b189ad233b0fa7e38bf3cb70f9aa019dc5964f18f52d9100b0bef100a-d_640x360?r=pad"}],"1990":[{"date":"1/1990","name":"Rachels 3rd Birthday","id":"490443139","thumbnail":"https://i.vimeocdn.com/video/1014521121-9950e762385d6b5b15a18f5d63cfa02b432c01d72fc01473c74d234449315db4-d_640x360?r=pad"},{"date":"12/25/1990","name":"Christmas","id":"487951877","thumbnail":"https://i.vimeocdn.com/video/1009851290-938f0d0ac53cf5c16df8ec33de583ff4991e06e2d711877ff9d6ad359fd94318-d_640x360?r=pad"},{"date":"01/14/1990","name":"Rachel rolling dough","id":"484494178","thumbnail":"https://i.vimeocdn.com/video/1003622405-136c6ee45c77269e43082c4424a4b3602bf89bedb14e3293ed357aa968e58e19-d_640x360?r=pad"},{"date":"01/07/1990","name":"Rachel's birthday","id":"484494096","thumbnail":"https://i.vimeocdn.com/video/1003927995-6a4fa99978a54604e42717cef1c1795f7c95be389f5f93a2ad6f47fc0d7a6782-d_640x360?r=pad"},{"date":"1990","name":"At the fair","id":"484493753","thumbnail":"https://i.vimeocdn.com/video/1003928551-1fa34d4f64ba5ae0794401bf0e64de36a5ee131bdda2a99d4fad36ef8ac41371-d_640x360?r=pad"}],"1991":[{"date":"10/20/1991","name":"Rachel and Taylor around the house","id":"493068213","thumbnail":"https://i.vimeocdn.com/video/1019634012-557736611454bf9abbca59a2985f0c5dcbf2b14c9d6b557a006fe096c7c74c9b-d_640x360?r=pad"},{"date":"12/25/1991","name":"Christmas","id":"493067367","thumbnail":"https://i.vimeocdn.com/video/1019632279-e9a051b3fb4aca5e30dd3cb64b08a0a28cb9c30c225200d2ce90cbbde94d0975-d_640x360?r=pad"},{"date":"8/27/1991","name":"Rachel and Taylor","id":"490441425","thumbnail":"https://i.vimeocdn.com/video/1014517903-cd99c7dfd4ae3c2ad81abf8c71d06f61e614c678ff2f6f7a9d5065958eb96d8a-d_640x360?r=pad"},{"date":"1/3/1991","name":"Rachel's 4th Birthday","id":"490439922","thumbnail":"https://i.vimeocdn.com/video/1014514812-415a00f21dd18417df8e3cc8ce2baac8b0291bc1a11fdc7892b71ee6bb950956-d_640x360?r=pad"},{"date":"11/1991","name":"Thanksgiving","id":"490439358","thumbnail":"https://i.vimeocdn.com/video/1014513396-4db6fa4cf0d8e12113b29f61ffecba5692cffa1510ab46da6d8ff5dd2ea652ff-d_640x360?r=pad"},{"date":"3/23/1991","name":"Taylor born","id":"485307927","thumbnail":"https://i.vimeocdn.com/video/1005011742-15b7d70215689c49fd491e8ea0380d79018a2147114d219a0dd0a857bede99fa-d_640x360?r=pad"}],"1992":[{"date":"12/1992","name":"Christmas","id":"493067153","thumbnail":"https://i.vimeocdn.com/video/1019631916-de8222478a10fc4a6fa6df6df71a0317a1f5a92e4b71c9797b0ddc524772bf0e-d_640x360?r=pad"},{"date":"10/1992","name":"Taylor in Yard","id":"487948191","thumbnail":"https://i.vimeocdn.com/video/1009843483-c7d37bea3bd5631682db7504677475475a5d3f47f2b59f0e2019eb92c6d9442c-d_640x360?r=pad"},{"date":"1/4/1992","name":"Rachel's fifth birthday","id":"487947493","thumbnail":"https://i.vimeocdn.com/video/1009841995-6133508640d61c20f60906b352bf9ee0976caa7f1b87511b72eeea9bb900e835-d_640x360?r=pad"},{"date":"1/19/1992","name":"Taylor in swing","id":"487947461","thumbnail":"https://i.vimeocdn.com/video/1009841492-a050c484dc345989047852a9e62c2a2b6d234f09bcb3f118126ffcd53b687ead-d_640x360?r=pad"},{"date":"03/01/1992","name":"Rachel and Taylor together","id":"485309839","thumbnail":"https://i.vimeocdn.com/video/1005014485-eb0a637573479e6d9c0b8516838dc91683ada6403c5e991611c6cfc7f1a74598-d_640x360?r=pad"},{"date":"3/23/1992","name":"Taylor's first birthday","id":"485309665","thumbnail":"https://i.vimeocdn.com/video/1005014325-7a48c0f8baabde0d7b26d5613eb395291eac7b41ded29d2ed5f9a6ebdb590371-d_640x360?r=pad"},{"date":"3/28/1992","name":"Playing inside and gardening","id":"485309432","thumbnail":"https://i.vimeocdn.com/video/1005013971-652631ada62c74af312e22c63d2d4d72a79cf61e1f53a1bf6e2ae660904b57b5-d_640x360?r=pad"},{"date":"4/19/1992","name":"Easter egg hunt","id":"485309361","thumbnail":"https://i.vimeocdn.com/video/1005013558-a9e740a3008e1de3027c4934c463d171e46b0601a3e36ac0d94806007ac1ef68-d_640x360?r=pad"}],"1993":[{"date":"12/1993","name":"Christmas pt 3","id":"490440843","thumbnail":"https://i.vimeocdn.com/video/1014516763-a7656ca880af80407435d901bb500a9c4e8f8f072590962bf53d4082a8f50bbf-d_640x360?r=pad"},{"date":"3/1993","name":"Taylor eating and in driveway","id":"490440753","thumbnail":"https://i.vimeocdn.com/video/1014516240-78cbfc6e6f4159824e871999608f210379c1ea643630e5fde9796b79575c5b20-d_640x360?r=pad"},{"date":"3/28/1993","name":"Rachel learns to ride a bike","id":"490439782","thumbnail":"https://i.vimeocdn.com/video/1014514270-9dcfff33827b5558bedda27a3b3fe0815f507f474dfafa22ffa6c5c7115d0f5e-d_640x360?r=pad"},{"date":"4/11/1993","name":"Easter","id":"490439647","thumbnail":"https://i.vimeocdn.com/video/1014514079-8af6ff1d2444fc0528ccd9ff5c0a382c6ca4d88c13566315d7a4221dd1f4b17f-d_640x360?r=pad"},{"date":"3/6/1993","name":"Skiing in Tahoe","id":"487948115","thumbnail":"https://i.vimeocdn.com/video/1009843472-af9b86f7bae34c974bf541748b007f7f6d3bd11b186750b58c6823a5bb941dcc-d_640x360?r=pad"},{"date":"3/21/1993","name":"Taylor's second birthday","id":"487947789","thumbnail":"https://i.vimeocdn.com/video/1009842828-4016636080f76ee9e2f29f4e2bbd8e54114c00458f0335f496f244943e1abf1e-d_640x360?r=pad"},{"date":"12/1993","name":"Christmas","id":"487947406","thumbnail":"https://i.vimeocdn.com/video/1009841622-442af5af8090abe5e6351fb0c9f12aea399dd9a1249d5c915006ae648dd0aec6-d_640x360?r=pad"},{"date":"12/1993","name":"Christmas Play","id":"487947307","thumbnail":"https://i.vimeocdn.com/video/1009841258-88e78cdb29e9d66c571c418d459fc3cdac89ab7e48544dfc0e14a941a37c8dce-d_640x360?r=pad"},{"date":"12/1993","name":"Christmas pt 2","id":"487947288","thumbnail":"https://i.vimeocdn.com/video/1009841171-028ec02570469cc9ae480410f56283fd810aee247aacfe66b1357ba77c51af3b-d_640x360?r=pad"},{"date":"1/10/1993","name":"Rachel's 6th birthday","id":"485308571","thumbnail":"https://i.vimeocdn.com/video/1005012500-9102c6151b6289ab41075b18e1cbb3fe7ee9260af0828da4b2e53cdb2de10df2-d_640x360?r=pad"},{"date":"2/7/1993","name":"Rachel and Taylor playing","id":"485308521","thumbnail":"https://i.vimeocdn.com/video/1005012213-d3ccf8bd4898a9e488031c7bb49aa1325a77273f3e81b75fd1da3b97478d6cc8-d_640x360?r=pad"}],"1994":[{"date":"3/6/1994","name":"Rachel and Lauren Farrer","id":"490442462","thumbnail":"https://i.vimeocdn.com/video/1014519738-b5cf5d678a126bd76d431082099e30cc69c5da845ad81e46aa941d908fdd26c3-d_640x360?r=pad"},{"date":"7/29/1994","name":"Santa Rosa Fair","id":"490441783","thumbnail":"https://i.vimeocdn.com/video/1014518359-f6ac066360efee41873991215c8ac5cc17a6f85403c6c8d2c8f98cbc28972d86-d_640x360?r=pad"},{"date":"11/1994","name":"Hike in woods","id":"490441682","thumbnail":"https://i.vimeocdn.com/video/1014518135-1d1a05f1f1bc780b80a083f12fc121dfc413d2ef98a2f91d3f3a7eb9586a16b1-d_640x360?r=pad"},{"date":"11/1994","name":"Rachel and Tessa puppetshow","id":"490439486","thumbnail":"https://i.vimeocdn.com/video/1014513618-47fb3d3d3849fa027fc4ea55850c9e55413913ed2bea4bb376e33eb06d0f3287-d_640x360?r=pad"},{"date":"1994","name":"Disneyland","id":"490438752","thumbnail":"https://i.vimeocdn.com/video/1014512488-e2cedd77977bd6d837df12ebfa952d483a067f2caa6c43b0545dafc2bb285331-d_640x360?r=pad"},{"date":"1994","name":"Halloween at home","id":"490437479","thumbnail":"https://i.vimeocdn.com/video/1014509658-4817b3cd436dc8ffaeb35e8bfd2a92e154cd633632d285a7feb53b81fdf87062-d_640x360?r=pad"}],"1995":[{"date":"6/8/1995","name":"Taylor's Graduation at Trinity","id":"490442038","thumbnail":"https://i.vimeocdn.com/video/1014518902-79292514c32bfe96fb3cf95b08c1dd56cb61ccbef1348aba846a12f2a00e54fc-d_640x360?r=pad"},{"date":"1995","name":"Rachel's school play","id":"490438141","thumbnail":"https://i.vimeocdn.com/video/1014510809-9e4b13ebbafb68657e7ad7af6002da7d50d0bd991fc59b71aa4d6b539550d310-d_640x360?r=pad"},{"date":"1995","name":"Rachel's school play","id":"490437406","thumbnail":"https://i.vimeocdn.com/video/1014509402-4e61875849c968b1b87d0bbd13f36870021bf62ee136e04cdf5f26e90ba1b75a-d_640x360?r=pad"},{"date":"8/12/1995","name":"JoAnn's surprise party pt 2","id":"487951498","thumbnail":"https://i.vimeocdn.com/video/1009850538-d9f95b8df61a9bf658cad26427d59062add45192907f42c4efc3583bf8c58af3-d_640x360?r=pad"},{"date":"8/12/1995","name":"JoAnn's surprise birthday","id":"487949090","thumbnail":"https://i.vimeocdn.com/video/1009845535-9f8a7eaaddd36b9902515c0530f63c1e0901e7a6893793665aeb84c8d21c2874-d_640x360?r=pad"},{"date":"1/1995","name":"Sun Valley Talent Show","id":"487947729","thumbnail":"https://i.vimeocdn.com/video/1009842315-0e58eb418013040d34bf1e482e96225ff4b6912ebcf07a290790948f29ff6e1d-d_640x360?r=pad"},{"date":"3/1995","name":"Flying rocket at Sun Valley School","id":"487947648","thumbnail":"https://i.vimeocdn.com/video/1009842196-4ab9ea70d47d73aa6e15d53fbb307c5ed902d7056c33da643897237679fbbd20-d_640x360?r=pad"},{"date":"3/19/1995","name":"Taylor's 4th birthday","id":"487947104","thumbnail":"https://i.vimeocdn.com/video/1009841206-81e02c2551424307f1bff386bb0eae8e1e7c69553c48e58b1522717c9f369c05-d_640x360?r=pad"},{"date":"10/31/1995","name":"Halloween at School","id":"485310024","thumbnail":"https://i.vimeocdn.com/video/1005014895-9c1d805b164ff99abb77e01bf95cbb309d58f54c03d53e4a7e357be1372958ff-d_640x360?r=pad"},{"date":"10/31/1995","name":"Halloween at Home","id":"485309938","thumbnail":"https://i.vimeocdn.com/video/1005014572-3e7b4ac8475f7fc5396179cb5173ea91afa7faa74f444f561c7fd0dd49035a1e-d_640x360?r=pad"}],"1996":[{"date":"1996","name":"Taylor playing baseball","id":"493068661","thumbnail":"https://i.vimeocdn.com/video/1019634578-531db5dc8a13994fec27dd731a5368d28d079cd996e85ee33c8d92b4d843a467-d_640x360?r=pad"},{"date":"3/23/1996","name":"Taylor birthday","id":"493067749","thumbnail":"https://i.vimeocdn.com/video/1019633301-8bd7ffaf3da75d62d80db191563738944622d1d28d52fb5cb92dbd417e652770-d_640x360?r=pad"},{"date":"9/3/1996","name":"Taylor's first bike ride","id":"490439202","thumbnail":"https://i.vimeocdn.com/video/1014513247-69d15e5c0144c5b141da1ebd3f0ec7dcdd650957c12ecd45a4aec3801361c0f2-d_640x360?r=pad"},{"date":"3/29/1996","name":"Rachel Folk Dance","id":"484493683","thumbnail":"https://i.vimeocdn.com/video/1003621581-fe70aa855645421335e37872673a1f6753c3a2e5e6954eff23dad6ab34d627ec-d_640x360?r=pad"}]}}

/***/ }),

/***/ 208:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SingleVideo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames_bind__ = __webpack_require__(128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_classnames_bind___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_classnames_bind__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_whatwg_fetch__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_visibility_sensor__ = __webpack_require__(194);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_visibility_sensor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_visibility_sensor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__App_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App_styl__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__App_styl___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__App_styl__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pw__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__pw___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__pw__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__favicon_ico__ = __webpack_require__(158);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__favicon_ico___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__favicon_ico__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(127);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }









// Using CSS Modules so we assign the styles to a variable

var cx = __WEBPACK_IMPORTED_MODULE_3_classnames_bind___default.a.bind(__WEBPACK_IMPORTED_MODULE_7__App_styl___default.a);



// Favicon link is in the template, this just makes webpack package it up for us



var storage = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* store */])();

var Video = function (_React$Component) {
  _inherits(Video, _React$Component);

  function Video(props) {
    _classCallCheck(this, Video);

    var _this = _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).call(this, props));

    _this.state = {};
    return _this;
  }

  _createClass(Video, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.load();
    }
  }, {
    key: 'load',
    value: function load() {
      var opts = {
        playsinline: false
      };
      if (__WEBPACK_IMPORTED_MODULE_10__utils__["b" /* isMobile */]) {
        opts.width = window.innerWidth;
      } else {
        var offset = document.getElementById('single-header').offsetHeight + document.getElementById('single-footer').offsetHeight + 30;

        opts.height = window.innerHeight - offset;
      }

      this.thePlayer = new Vimeo.Player('video-' + this.props.id, opts);
    }
  }, {
    key: 'markAsPlayed',
    value: function markAsPlayed() {
      var playedVideos = JSON.parse(storage.getItem('playedVideos') || '{}');
      playedVideos[this.props.id] = new Date().getTime();
      storage.setItem('playedVideos', JSON.stringify(playedVideos));
    }
  }, {
    key: 'play',
    value: function play() {
      var _this2 = this;

      this.load();
      this.markAsPlayed();
      this.thePlayer.on('play', function () {
        _this2.thePlayer.requestFullscreen();
      });
      this.thePlayer.on('fullscreenchange', function (_ref) {
        var fullscreen = _ref.fullscreen;

        if (!fullscreen) _this2.thePlayer.pause();
      });
    }
  }, {
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: cx('main-video') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div', {
          id: 'video-' + this.props.id,
          'data-vimeo-id': this.props.id,
          className: cx('video-player')
        })
      );
    }
  }]);

  return Video;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var Header = function (_React$Component2) {
  _inherits(Header, _React$Component2);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, [{
    key: 'render',
    value: function render() {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: cx('single-header'), id: 'single-header' },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('header-text') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'h1',
            null,
            'Stein Family'
          ),
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'div',
            { className: cx('h2-background') },
            __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
              'h2',
              null,
              'Home Videos'
            )
          )
        )
      );
    }
  }]);

  return Header;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

var SingleVideo = function (_React$Component3) {
  _inherits(SingleVideo, _React$Component3);

  function SingleVideo(props) {
    _classCallCheck(this, SingleVideo);

    var _this4 = _possibleConstructorReturn(this, (SingleVideo.__proto__ || Object.getPrototypeOf(SingleVideo)).call(this, props));

    _this4.state = {};
    return _this4;
  }

  _createClass(SingleVideo, [{
    key: 'onChange',
    value: function onChange() {
      this.setState({
        thing: Math.random()
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      setTimeout(function () {
        var vh = window.innerHeight * 0.01;
        document.documentElement.style.setProperty('--vh', vh + 'px');
      }, 500);
    }
  }, {
    key: 'render',
    value: function render() {
      var userPass = storage.getItem('password');
      // FOR BUiLD
      if (userPass == '__IS_BUILD__') {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('page') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Header, null)
        );
      }

      if (!userPass || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_10__utils__["c" /* hashPass */])(userPass) !== +__WEBPACK_IMPORTED_MODULE_8__pw___default.a) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('page') },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__App_js__["d" /* Auth */], { onChange: this.onChange.bind(this) })
        );
      }

      var videoId = this.props.params.videoId;


      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
        'div',
        { className: cx('single-video') },
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Header, null),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Video, { id: videoId }),
        __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
          'div',
          { className: cx('back-home'), id: 'single-footer' },
          __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
            'a',
            { className: cx('back-home-btn'), href: '/' },
            '\u2190 Back to all videos'
          )
        )
      );
    }
  }]);

  return SingleVideo;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);
SingleVideo.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node
};

/***/ }),

/***/ 209:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export routes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router__ = __webpack_require__(53);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_App_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_SingleVideo_js__ = __webpack_require__(208);






var routes = __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
  __WEBPACK_IMPORTED_MODULE_1_react_router__["Route"],
  { path: '/', component: __WEBPACK_IMPORTED_MODULE_2__components_App_js__["a" /* App */] },
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["IndexRoute"], { title: 'Stein Family Videos', component: __WEBPACK_IMPORTED_MODULE_2__components_App_js__["b" /* Home */] }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"], { path: '/video/:videoId', title: 'Stein Family Videos', component: __WEBPACK_IMPORTED_MODULE_3__components_SingleVideo_js__["a" /* SingleVideo */] }),
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router__["Route"], { path: '*', title: '404: Not Found', component: __WEBPACK_IMPORTED_MODULE_2__components_App_js__["c" /* NotFound */] })
);

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ 344:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "react-logo.28e8a90b.png";

/***/ }),

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "background.11302d3f.jpg";

/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "lock.78415eb4.png";

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "share.bca670ef.png";

/***/ }),

/***/ 457:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(204);
__webpack_require__(203);
__webpack_require__(82);
module.exports = __webpack_require__(201);


/***/ })

},[457]);


// WEBPACK FOOTER //
// app.6bd115a8.js